import Bookmarks from './bookmarks';

const Dialog = {
	dialog: document.getElementById('map-dialog'),
	_triggerElement: null,

	/**
	 * @param {string} url - The URL to load in the dialog
	 * @returns {DOM element} The dialog element.
	 */
	load: async function (url) {
		this._triggerElement = document.activeElement;
		await fetch(url)
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}
				return response.text();
			})
			.then(async (response) => {
				this.dialog.innerHTML = response;
				const tabGroup = this.dialog.querySelector('sl-tab-group');
				if (tabGroup) {
					await tabGroup.updateComplete;
				}
				if (document.querySelector('.bookmark-button-container')) {
					Bookmarks.buildButtons();
				}
				this.dialog.show();
			});
		return this.dialog;
	},

	/**
	 * Load a content string
	 * @param {string} content - HTML content to load
	 * @returns {DOM element} The dialog element.
	 */
	loadContent: async function (content) {
		this._triggerElement = document.activeElement;
		this.dialog.innerHTML = content;
		this.dialog.show();
		return this.dialog;
	},

	close: function () {
		this.dialog.hide();
	},

	addListeners: () => {
		document.addEventListener('sl-show', (e) => {
			if (e.target.tagName === 'SL-DIALOG') {
				e.target.addEventListener('sl-after-hide', Dialog.handleClose);
			}
		});
	},

	handleClose: function (e) {
		if (e.target.tagName === 'SL-DIALOG') {
			e.target.removeEventListener('sl-after-hide', Dialog.handleClose);
			Dialog.close();
			Dialog.resetClass();

			// if there is an open popup, focus its more_button
			if (W.popups.length) {
				setTimeout(() => {
					document.querySelector('[data-key=' + W.popups[0].key + '] .more_button').focus();
				});
			} else if (Dialog._triggerElement && document.body.contains(Dialog._triggerElement)) {
				Dialog._triggerElement.focus();
			}
			Dialog._triggerElement = null;
		}
	},

	resetClass: function () {
		this.dialog.setAttribute('class', 'uw-dialog');
		this.dialog.style.removeProperty('--width');
	},
};

Dialog.addListeners();

export default Dialog;
